











































































































import {
  createOrUpdateProduct,
  getProducts,
  toggleBalanceTrasnferStatus,
  getBalanceTransferStatus,
} from '@/api/Topup/topup.api'
import ActionButton from '@/components/ActionButton.vue'
import { AxiosError } from 'axios'
import { GetProductDTO, Product } from '@/utils/interfaces/topup.interface'
import CreateProductDialog from '@/components/Services/TopUps/CreateProductDialog.vue'
import ProductProviderCodesDialog from '@/components/Services/TopUps/ProductProviderCodesDialog.vue'
import { TableHeader } from '@/utils/interfaces'
import { tableHandler } from '@/utils/mixins/tableHandler'
import IconButton from '~/components/IconButton.vue'
import FlatTable from '~/components/FlatTable.vue'
import FlatCard from '~/components/FlatCard.vue'
import TextButton from '~/components/TextButton.vue'
import { productsCode } from '~/utils/productsCode.constant'
import ViewFilter from '~/components/ViewFilter.vue'
import TableSwitch from '~/components/TableSwitch.vue'
import ConfirmDialog from '~/components/ConfirmDialog.vue'

export default tableHandler<Product>().extend({
  components: {
    appCreateProductDialog: CreateProductDialog,
    appProductProviderCodesDialog: ProductProviderCodesDialog,
    appActionButton: ActionButton,
    IconButton,
    FlatTable,
    FlatCard,
    ConfirmDialog,
    TextButton,
    ViewFilter,
    TableSwitch,
  },
  data() {
    return {
      headers: [
        {
          text: this.$t('name'),
          value: 'name',
        },
        {
          text: this.$t('amount'),
          value: 'amount',
        },
        {
          text: this.$t('code'),
          value: 'full_code',
        },
        {
          text: this.$t('destination_amount'),
          value: 'destination_amount',
        },
        {
          text: this.$t('used_by_subagents'),
          value: 'used_by_subagents',
        },
        {
          text: this.$t('show_to_clients'),
          value: 'show_to_clients',
          notShow: !(this.$p.isMaikel || this.$p.isSuperuser),
        },
        {
          text: this.$t('enable_transfer'),
          value: 'enable_transfer',
          notShow: !(this.$p.isMaikel || this.$p.isSuperuser),
        },
        {
          text: this.$t('actions'),
          value: 'actions',
        },
      ] as TableHeader[],
      products: [] as number[],
      getter: getProducts,
      dialogModel: false,
      providerCodesDialog: false,
      selectedProduct: null as GetProductDTO | null,
      loadingItem: null as null | Product,
      productsCode,
      balanceTransferStatus: {
        is_active: true,
      },
      loading: false,
      confirmDialog: false,
    }
  },
  methods: {
    async onChange(item: GetProductDTO) {
      try {
        this.loadingItem = item
        await createOrUpdateProduct({
          uuid: item.uuid,
          used_by_subagents: item.used_by_subagents,
        })
      } finally {
        this.loadingItem = null
      }
    },
    onShowProviderCodes(item: GetProductDTO) {
      this.selectedProduct = item
      this.providerCodesDialog = true
    },
    async toggle(item: GetProductDTO) {
      try {
        this.loadingItem = item
        await createOrUpdateProduct(item)
      } finally {
        this.loadingItem = null
      }
    },
    async toggleBalanceTrasnferStatus() {
      try {
        this.loading = true
        await toggleBalanceTrasnferStatus(this.balanceTransferStatus)
        this.$toast.success(this.$t('topup.balance_transfer_status_changed'))
      } catch (error) {
        if ((error as AxiosError)?.response?.data) {
          this.balanceTransferStatus.is_active = !this.balanceTransferStatus
            .is_active
        }
        this.$toast.error(
          this.$t('topup.balance_transfer_status_change_failed'),
        )
      }
      this.loading = false
    },
  },
  async mounted() {
    if (!(this.$p.isMaikel || this.$p.isSuperuser)) return
    try {
      const response = await getBalanceTransferStatus()
      this.balanceTransferStatus.is_active = response.data.is_active
    } catch {
      try {
        const response = await getBalanceTransferStatus()
        this.balanceTransferStatus.is_active = response.data.is_active
      } catch {
        this.$toast.error(this.$t('pre_topup_status_fetch_failed'))
      }
    }
  },
})
